// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__uIR37","copyright":"Footer_copyright__bV3Zo"};